import { render, staticRenderFns } from "./SortByAmount.vue?vue&type=template&id=6034b8c8&scoped=true"
import script from "./SortByAmount.vue?vue&type=script&lang=js"
export * from "./SortByAmount.vue?vue&type=script&lang=js"
import style0 from "./SortByAmount.vue?vue&type=style&index=0&id=6034b8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6034b8c8",
  null
  
)

export default component.exports